import { ViteReactSSG } from 'vite-react-ssg'
import { ServerStyleSheet } from 'styled-components'
import { routes } from './App.jsx'

export const createRoot = ViteReactSSG(
  { routes },
  ({ router, routes, isClient, initialState }) => {
    // Client-side initialization if needed
  },
  {
    getStyleCollector: () => {
      const sheet = new ServerStyleSheet()
      return {
        collect: (app) => sheet.collectStyles(app),
        /**
         * Include charset meta tag with the collected styles.
         *
         * Why here? During SSG, vite-react-ssg collects styles from styled-components
         * and prepends them to <head>. Since these styles can exceed 1024 bytes, and
         * browsers require charset declaration within the first 1024 bytes for proper
         * encoding detection, we must include the charset tag BEFORE the styles.
         *
         * This is the correct place to inject it because this entire output (charset + styles)
         * gets prepended as a single block to <head> during the SSG build process.
         */
        toString: () => '<meta charset="UTF-8">' + sheet.getStyleTags(),
      }
    }
  }
)